var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailure = function SvgFailure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 101,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.049 85.595 63.409 5.29a10.116 10.116 0 0 0-17.782 0L2.02 85.595a10.117 10.117 0 0 0 8.892 15.049h87.247a10.116 10.116 0 0 0 8.891-14.924v-.125ZM50.497 25.24a4.398 4.398 0 1 1 8.797 0v37.701a4.398 4.398 0 1 1-8.797 0V25.241Zm4.399 62.364a5.655 5.655 0 1 1 0-11.31 5.655 5.655 0 0 1 0 11.31Z"
  })));
};
export default SvgFailure;